<template>
  <v-dialog v-model="show" persistent width="300">
    <v-card color="primary" dark>
      <v-card-text>
        {{ title }}
        <v-progress-linear
          color="white"
          class="mb-0"
          indeterminate
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: { type: String, default: "" },
    show: { type: Boolean, default: false },
  },
};
</script>

<style></style>
